import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { FaEdit, FaTrashAlt } from 'react-icons/fa'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import DestinationsService from '../../../../services/DestinationsService'
import {isArrayNotEmpty, isCompletedHotelInfoHistory, isObjectEmpty, scrollToHtmlElementById} from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Button from '../../../atoms/Button/Button'
import SelectInput from '../../../atoms/form/SelectInput/SelectInput'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import ToggleSwitch from '../../../atoms/form/ToggleSwitch/ToggleSwitch'
import TextAreaInput from '../../../atoms/form/TextAreaInput/TextAreaInput'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './Restaurants.scss'
import { locationOptions, dressCodeOptions, validationSchemaHotelDiningContent } from '../../../../constants/RestaurantHotelContentConst'
import OperatingHours from "../../../atoms/form/OperatingHours/OperatingHours";

class Restaurants extends Component {

    constructor(props) {
        super(props)
        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)

        if (!hotelCode || !hotelInfo) {
            this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
        }

        const hotelBrandCode = hotelInfo.brandCode;
        const isHotelDomestic = getSessionItem(SessionConst.IS_HOTEL_DOMESTIC);
        let availableHotelContent = FormConst.HOTEL_CONTENT_DEFAULT_SECTIONS[hotelBrandCode];
        let canAccessHotelContentDining =  false;
        if (availableHotelContent !== undefined && availableHotelContent.includes('D') 
            && !(hotelBrandCode == FormConst.HOTEL_CONTENT_INTERNATIONAL_ONLY_BRAND && isHotelDomestic == FormConst.VALUE_YES)) {
            canAccessHotelContentDining = true;
        }

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            continueFlow: this.props.history.location?.state?.continueFlow,
            distanceUnits: getSessionItem(SessionConst.DISTANCE_UNIT_LABEL),
            restaurants: [],
            otherDestinationEntries: {},
            isEdit: false,
            editIndex: -1,
            showNewRestaurantFields: false,
            deleteIndex: -1,
            showDeleteModal: false,
            locationOptions: locationOptions,
            dressCodeOptions: dressCodeOptions,
            canAccessHotelContentDining: canAccessHotelContentDining,
            initialValues: { ...this.initialValues },
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            hotelInfoCompletedHistory: hotelInfoCompletedHistory
        }
    }

    /**
     * Lifecycle method that runs after the component mounts.
     * Gets data from the session if state is COMPLETED, otherwise from the service, and sets initial values for the form.
     */
    async componentDidMount() {
        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
            let hotelDestinations = this.state.hotelInfoCompletedHistory.newEntity?.hotelDestinations?.hotelDestinations;

            if (hotelDestinations) {
                await this.buildFormValues(hotelDestinations);
            } else {
                this.setState({ error: 'Could not retrieve details', isLoading: false })
            }
        } else {
            await DestinationsService.getHotelDestinations({ hotelCode: this.state.hotelCode })
                .then(async response => {
                    let hotelDestinations = response?.hotelDestinations;

                    if (hotelDestinations) {
                        await this.buildFormValues(hotelDestinations);
                    }
                }).catch(error => {
                    this.setState({ error: 'Could not retrieve details', isLoading: false })
                })
        }
    }

    async buildFormValues(hotelDestinations) {
        let existingRestaurants = []
        let otherDestinationEntries = {}
        const restaurants = hotelDestinations.restaurant;
        otherDestinationEntries = !isObjectEmpty(hotelDestinations)
            ? {
                ...hotelDestinations,
                restaurant: undefined
            }
            : { restaurant: undefined };
        if (restaurants) {
            existingRestaurants = restaurants && restaurants.length > 0 ? [...restaurants] : []
        }
        
        await DestinationsService.getAcceptableValues({
            hotelCode: this.state.hotelCode, queryParams: {
                code: FormConst.DESTINATION_CODE_RESTAURANT_SPECIALITY
            }
        }).then(acceptableValuesResponse => {
            this.setState({
                restaurants: existingRestaurants,
                otherDestinationEntries: otherDestinationEntries,
                isLoading: false,
                restaurantSpecialtyOptions: acceptableValuesResponse.acceptableValues.map(option => {
                    return {
                        label: option.value,
                        value: option.key
                    }
                })
            })
        }).catch(error => {
            this.setState({
                restaurants: existingRestaurants,
                otherDestinationEntries: otherDestinationEntries,
                error: 'Could not restaurant specialty details',
                showErrorModal: true,
                isLoading: false
            })
        })
    }

    //Empty Values for loading Editable Entries without them
    mealTypes = ['DAILY', 'BREAKFAST', 'BRUNCH', 'LUNCH', 'HAPPY_HOUR', 'DINNER'];
    dailyDoesntVaryTemplate = { "hours" : { "allDays": {"open": '', "close" : '' }}}
    dailyTemplate = { "hours" : {
            "mon" : {"open": '', "close" : '', "closed": false}, "tue" : {"open": '', "close" : '', "closed": false},
            "wed" : {"open": '', "close" : '', "closed": false}, "thu" : {"open": '', "close" : '', "closed": false},
            "fri" : {"open": '', "close" : '', "closed": false}, "sat" : {"open": '', "close" : '', "closed": false},
            "sun" : {"open": '', "close" : '', "closed": false}
        }
    }


    initialValues = {
        restaurantName: '',
        locationToHotel: '',
        isBreakfast: false,
        isLunch: false,
        isDinner: false,
        distance: 0,
        direction: '',
        openingTime: '',
        closingTime: '',
        speciality: '',

        shortDescription: '',
        sameOperatingHours: true,
        detailedOperatingHoursVary: false,
        diningHoursVary: false,
        canAccessHotelContentDining: false,
        detailedOperatingHours : {
            dailyDoesntVary: structuredClone(this.dailyDoesntVaryTemplate),
            DAILY: structuredClone(this.dailyTemplate),
            BREAKFAST: structuredClone(this.dailyTemplate),
            BRUNCH: structuredClone(this.dailyTemplate),
            LUNCH: structuredClone(this.dailyTemplate),
            HAPPY_HOUR: structuredClone(this.dailyTemplate),
            DINNER: structuredClone(this.dailyTemplate)
        }
    }

    nullOutUnusedTimes(data) {
        let nullOutDoesNotVary = false;
        let nullOutDaily = false;
        let nullOutTimesVary = false;
        if (data.sameOperatingHours) {
            nullOutDaily = true;
            nullOutTimesVary = true;
        } else if (data.diningHoursVary) {
            nullOutDoesNotVary = true;
            nullOutDaily = true;
            this.clearOutClosedTimes(data.detailedOperatingHours.BREAKFAST);
            this.clearOutClosedTimes(data.detailedOperatingHours.BRUNCH);
            this.clearOutClosedTimes(data.detailedOperatingHours.LUNCH);
            this.clearOutClosedTimes(data.detailedOperatingHours.HAPPY_HOUR);
            this.clearOutClosedTimes(data.detailedOperatingHours.DINNER);
        } else {
            nullOutDoesNotVary = true;
            nullOutTimesVary = true;
            this.clearOutClosedTimes(data.detailedOperatingHours.DAILY);
        }
        if (nullOutDoesNotVary) {
            delete data.detailedOperatingHours.dailyDoesntVary;
        }
        if (nullOutDaily) {
            delete data.detailedOperatingHours.DAILY;
        }
        if (nullOutTimesVary) {
            delete data.detailedOperatingHours.BREAKFAST;
            delete data.detailedOperatingHours.BRUNCH;
            delete data.detailedOperatingHours.LUNCH;
            delete data.detailedOperatingHours.HAPPY_HOUR;
            delete data.detailedOperatingHours.DINNER;
        }
        if (!data.breakfastCheckbox) {delete data.detailedOperatingHours.BREAKFAST}
        if (!data.brunchCheckbox) {delete data.detailedOperatingHours.BRUNCH}
        if (!data.lunchCheckbox) {delete data.detailedOperatingHours.LUNCH}
        if (!data.happyHourCheckbox) {delete data.detailedOperatingHours.HAPPY_HOUR}
        if (!data.dinnerCheckbox) {delete data.detailedOperatingHours.DINNER}
    }

    clearOutClosedTimes(data) {
        if (data.hours.mon.closed) {
            delete data.hours.mon.open;
            delete data.hours.mon.close;
        }
        if (data.hours.tue.closed) {
            delete data.hours.tue.open;
            delete data.hours.tue.close;
        }
        if (data.hours.wed.closed) {
            delete data.hours.wed.open;
            delete data.hours.wed.close;
        }
        if (data.hours.thu.closed) {
            delete data.hours.thu.open;
            delete data.hours.thu.close;
        }
        if (data.hours.fri.closed) {
            delete data.hours.fri.open;
            delete data.hours.fri.close;
        }
        if (data.hours.sat.closed) {
            delete data.hours.sat.open;
            delete data.hours.sat.close;
        }
        if (data.hours.sun.closed) {
            delete data.hours.sun.open;
            delete data.hours.sun.close;
        }
    }

    formatPhoneNumber(phoneNumberString) {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return match[1] + '-' + match[2] + '-' + match[3];
        }
        return null;
    }

    handleSubmit = (formData) => {
        let restaurants = this.state.restaurants.length > 0 ? [...this.state.restaurants] : []

        let newEntry = {
            destinationType: 'RESTAURANT',
            name: formData.restaurantName.trim(),
            proximity: {
                location: formData.locationToHotel,
                distanceValue: formData.locationToHotel === FormConst.VALUE_NEARBY ? formData.distance : 0,
                distanceUnit: this.state.distanceUnits,
                direction: formData.locationToHotel === FormConst.VALUE_NEARBY ? formData.direction : undefined
            },
            breakfastAvailable: formData.isBreakfast,
            lunchAvailable: formData.isLunch,
            dinnerAvailable: formData.isDinner,
            brunchAvailable: false,
            happyHourAvailable: false,
            restaurantSpeciality: {
                code: formData.speciality,
                description: formData.speciality
            },
            operatingHours: formData.openingTime && formData.closingTime
                ? {
                    open: formData.openingTime,
                    close: formData.closingTime
                }
                : undefined
        }

        if (this.state.canAccessHotelContentDining && formData.locationToHotel === FormConst.VALUE_ONSITE) {
            //We have to massage the details data given the structure is not something the form can replicate.
            let formCopy = structuredClone(formData);
            let restaurantSpeciality = {};
            if (formData.typeOfCuisine) {
                restaurantSpeciality.code = formData.typeOfCuisine;
                restaurantSpeciality.description = formData.typeOfCuisine;
            }
            if (formData.dressCode) {
                restaurantSpeciality.dressCode = formData.dressCode;
            }
            if (formData.email) {
                restaurantSpeciality.email = formData.email;
            }
            if (formData.menuUrl) {
                restaurantSpeciality.menuUrl = formData.menuUrl;
            }
            formData.restaurantSpeciality = restaurantSpeciality;
            this.nullOutUnusedTimes(formCopy);
            newEntry = { 
                ...newEntry,
                code: formData.code,
                description: formData.shortDescription,
                url: formData.websiteUrl,
                phoneNumber: {
                    areaCode: formData.phoneAreaCode,
                    countryCode: formData.phoneCountryCode,
                    number: this.formatPhoneNumber(formData.phoneNumber),
                    preferred: false
                },
                locationInfo: {
                    location: formData.detailedLocation
                }
            }
            if (formData.sameOperatingHours) {
                newEntry.operatingHours = {
                    open: formData.detailedOperatingHours.dailyDoesntVary.hours.allDays.open,
                    close: formData.detailedOperatingHours.dailyDoesntVary.hours.allDays.close
                }
            } else {
                newEntry.detailedOperatingHours = formCopy.detailedOperatingHours;
                delete newEntry.operatingHours;
            }
            newEntry.restaurantSpeciality = restaurantSpeciality;
            newEntry.breakfastAvailable = formData.diningHoursVary ? !!formData.breakfastCheckbox : !!formData.isBreakfast;
            newEntry.lunchAvailable  = formData.diningHoursVary ? !!formData.lunchCheckbox  : !!formData.isLunch;
            newEntry.dinnerAvailable = formData.diningHoursVary ? !!formData.dinnerCheckbox : !!formData.isDinner;
            newEntry.brunchAvailable = !!formData.brunchCheckbox;
            newEntry.happyHourAvailable = !!formData.happyHourCheckbox;
            if (("Floor" === formData.detailedLocation || "Other" === formData.detailedLocation)) {
                newEntry.locationInfo.description = formData.detailedLocationDescription;
            }
        }
        if (this.state.isEdit) {
            // Edit existing entry
            restaurants[this.state.editIndex] = newEntry
        } else {
            restaurants.push(newEntry)
        }

        let newDestinationEntries
        if (this.state.otherDestinationEntries) {
            newDestinationEntries = {
                ...this.state.otherDestinationEntries,
                restaurant: [...restaurants]
            }
        } else {
            newDestinationEntries = {
                restaurant: [...restaurants]
            }
        }

        this.props.onPut({ hotelCode: this.state.hotelCode, formData: newDestinationEntries })

        this.setState({
            pendingRestaurants: [...restaurants],
            newPendingRestaurant: { ...formData },
            isLoading: true,
            loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT,
            formError: undefined
        })
    }

    handleDelete = (index) => {
        this.setState({ showDeleteModal: true, deleteIndex: index })
    }

    handleClearForm = () => {
        this.setState({ showResetModal: true })
    }

    discardNewFields = (formikResetForm) => {
        formikResetForm({ ...this.initialValues })
        // Scroll the table into view after discarding
        scrollToHtmlElementById('restaurants-table')
        this.setState({
            initialValues: { ...this.initialValues },
            isEdit: false,
            editIndex: -1,
            showNewRestaurantFields: false,
            showResetModal: false,
            formError: undefined
        })
    }

    handleProceed = () => {
        // Continue to next form
        if (this.state.continueFlow) {
            // Go to the next page
            this.props.history.push({
                pathname: RouteConst.ROUTE_LOUNGES_PAGE,
                state: {
                    continueFlow: this.state.continueFlow
                }
            })
        } else {
            // Go back to Destinations page
            this.props.history.push(RouteConst.ROUTE_DESTINATIONS_PAGE)
        }
    }

    setDefaultClosed(data) {
        //Set the default closed values for the meal types that are not selected to match with existing closed values.
        if (!data.diningHoursVary) return;

        let templateMeal = null;

        if (data.breakfastCheckbox) templateMeal = data.detailedOperatingHours.BREAKFAST;
        else if (data.brunchCheckbox) templateMeal = data.detailedOperatingHours.BRUNCH;
        else if (data.lunchCheckbox) templateMeal = data.detailedOperatingHours.LUNCH;
        else if (data.happyHourCheckbox) templateMeal = data.detailedOperatingHours.HAPPY_HOUR;
        else if (data.dinnerCheckbox) templateMeal = data.detailedOperatingHours.DINNER;

        if (templateMeal == null) return;

        for (const [key, value] of Object.entries(data.detailedOperatingHours)) {
            if (key === 'dailyDoesntVary') {
                continue;
            }
            value.hours.mon.closed = templateMeal.hours.mon.closed;
            value.hours.tue.closed = templateMeal.hours.tue.closed;
            value.hours.wed.closed = templateMeal.hours.wed.closed;
            value.hours.thu.closed = templateMeal.hours.thu.closed;
            value.hours.fri.closed = templateMeal.hours.fri.closed;
            value.hours.sat.closed = templateMeal.hours.sat.closed;
            value.hours.sun.closed = templateMeal.hours.sun.closed;
        }
    }

    onEdit = (index) => {
        const entryToEdit = structuredClone(this.state.restaurants[index])

        if (entryToEdit.proximity === undefined) {
            entryToEdit.proximity = {
                location: FormConst.VALUE_ONSITE,
                distanceValue: 0,
                direction: ''
            }
        }

        let editEntry = {
            restaurantName: entryToEdit.name,
            locationToHotel: entryToEdit.proximity.location,
            isBreakfast: entryToEdit.breakfastAvailable || false,
            isLunch: entryToEdit.lunchAvailable || false,
            isDinner: entryToEdit.dinnerAvailable || false,
            distance: entryToEdit.proximity.distanceValue,
            direction: entryToEdit.proximity.direction,
            openingTime: entryToEdit.operatingHours ? entryToEdit.operatingHours.open : null,
            closingTime: entryToEdit.operatingHours ? entryToEdit.operatingHours.close : null,
            speciality: entryToEdit.restaurantSpeciality ? entryToEdit.restaurantSpeciality.code : ''
        }

        if (this.state.canAccessHotelContentDining) {
            //We need to set the missing time values if those don't exist so there are no errors on page
            let sameOperatingHours = false;
            let diningHoursVary = false;
            if (entryToEdit.detailedOperatingHours) {
                if (entryToEdit.operatingHours) {
                    sameOperatingHours = true;
                }
                if (entryToEdit.detailedOperatingHours.BREAKFAST || entryToEdit.detailedOperatingHours.BRUNNCH 
                    || entryToEdit.detailedOperatingHours.LUNCH || entryToEdit.detailedOperatingHours.HAPPY_HOUR
                    || entryToEdit.detailedOperatingHours.DINNER
                ) {
                    sameOperatingHours = false;
                    diningHoursVary = true;
                }
            } else {
                sameOperatingHours = true;
            }

            if (entryToEdit.detailedOperatingHours !== undefined) {
                editEntry.detailedOperatingHours = {};
            }
            if (sameOperatingHours) {
                editEntry.detailedOperatingHours = {
                    dailyDoesntVary: {
                        hours: {
                            allDays: {
                                open: entryToEdit.operatingHours ? entryToEdit.operatingHours.open : '',
                                close: entryToEdit.operatingHours ? entryToEdit.operatingHours.close : ''
                            }
                        }
                    }
                }
            }
            editEntry = {
                ...editEntry,
                shortDescription: entryToEdit.description ? entryToEdit.description : "",
                sameOperatingHours: sameOperatingHours,
                diningHoursVary: diningHoursVary,
                breakfastCheckbox: !!(entryToEdit.detailedOperatingHours && entryToEdit.detailedOperatingHours.BREAKFAST),
                brunchCheckbox: !!(entryToEdit.detailedOperatingHours && entryToEdit.detailedOperatingHours.BRUNCH),
                lunchCheckbox: !!(entryToEdit.detailedOperatingHours && entryToEdit.detailedOperatingHours.LUNCH),
                happyHourCheckbox: !!(entryToEdit.detailedOperatingHours && entryToEdit.detailedOperatingHours.HAPPY_HOUR),
                dinnerCheckbox: !!(entryToEdit.detailedOperatingHours && entryToEdit.detailedOperatingHours.DINNER),
                phoneCountryCode: entryToEdit.phoneNumber ? entryToEdit.phoneNumber.countryCode : "",
                phoneAreaCode: entryToEdit.phoneNumber ? entryToEdit.phoneNumber.areaCode : "",
                phoneNumber: entryToEdit.phoneNumber && entryToEdit.phoneNumber.number? entryToEdit.phoneNumber.number.replace(/-/g, '') : "",
                email: entryToEdit.restaurantSpeciality ? entryToEdit.restaurantSpeciality.email : '',
                dressCode: entryToEdit.restaurantSpeciality ? entryToEdit.restaurantSpeciality.dressCode : '',
                websiteUrl: entryToEdit.url,
                menuUrl: entryToEdit.restaurantSpeciality ? entryToEdit.restaurantSpeciality.menuUrl : '',
                typeOfCuisine: entryToEdit.restaurantSpeciality ? entryToEdit.restaurantSpeciality.code : '',
                detailedLocation: entryToEdit.locationInfo ? entryToEdit.locationInfo.location : "",
                detailedLocationDescription: entryToEdit.locationInfo ? entryToEdit.locationInfo.description : ""
            }
            if (entryToEdit.detailedOperatingHours !== undefined) {
                editEntry.detailedOperatingHours = entryToEdit.detailedOperatingHours;
            }

            this.mealTypes.forEach(mealType => {
                if (!editEntry.detailedOperatingHours[mealType]) {
                    editEntry.detailedOperatingHours[mealType] = structuredClone(this.dailyTemplate);
                }
            });

            if (!editEntry.detailedOperatingHours) {
                editEntry.detailedOperatingHours = {
                    dailyDoesntVary: structuredClone(this.dailyDoesntVaryTemplate),
                    DAILY: structuredClone(this.dailyTemplate),
                    BREAKFAST: structuredClone(this.dailyTemplate),
                    BRUNCH: structuredClone(this.dailyTemplate),
                    LUNCH: structuredClone(this.dailyTemplate),
                    HAPPY_HOUR: structuredClone(this.dailyTemplate),
                    DINNER: structuredClone(this.dailyTemplate)
                }
            }
            this.setDefaultClosed(editEntry);
        }
        this.setState({
            isEdit: true,
            editIndex: index,
            initialValues: editEntry,
            showNewRestaurantFields: true,
            formError: undefined
        })

    }

    onDelete = () => {
        let index = this.state.deleteIndex
        let restaurants = [...this.state.restaurants]
        restaurants.splice(index, 1)

        let newDestinationEntries

        if (restaurants.length > 0 && !isObjectEmpty(this.state.otherDestinationEntries)) {
            newDestinationEntries = {
                ...this.state.otherDestinationEntries,
                restaurant: [...restaurants]
            }
        } else if (restaurants.length > 0) {
            newDestinationEntries = {
                restaurant: [...restaurants]
            }
        } else {
            newDestinationEntries = {
                ...this.state.otherDestinationEntries
            }
        }

        this.props.onPut({ hotelCode: this.state.hotelCode, formData: newDestinationEntries })

        this.setState({
            pendingRestaurants: [...restaurants],
            newPendingRestaurant: undefined,
            isLoading: true,
            loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT,
            showDeleteModal: false,
            formError: undefined
        })
    }

    showNewRestaurantFields = () => {
        this.setState({
            isEdit: false, editIndex: -1, showNewRestaurantFields: true, restaurantCodeOptions: [], formError: undefined
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    errorMessage: this.props.errorDescription,
                    pendingRestaurants: undefined,
                    newPendingRestaurant: undefined,
                    initialValues: {
                        ...this.initialValues,
                        ...this.state.newPendingRestaurant
                    }
                })
            } else {
                // Scroll the table into view after saving
                scrollToHtmlElementById('restaurants-table')
                this.setState({
                    isLoading: false, restaurants: this.state.pendingRestaurants,
                    initialValues: { ...this.initialValues }, showNewRestaurantFields: false,
                    isEdit: false, editIndex: -1, deleteIndex: -1, showDeleteModal: false
                })
            }
        }
    }

    render() {
        let formTable = <table id='restaurants-table' className='table table-striped restaurants-table'>
            <thead>
                <tr>
                    <th>Restaurant Name</th>
                    <th className='d-none d-xl-table-cell'>Location</th>
                    <th className='d-none d-xl-table-cell'>Breakfast</th>
                    <th className='d-none d-xl-table-cell'>Lunch</th>
                    <th className='d-none d-xl-table-cell'>Dinner</th>
                    <th className='d-none d-lg-table-cell'>Specialty</th>
                    <th>Edit</th>
                    <th>Delete</th>
                </tr>
            </thead>
            <tbody>
                {
                    isArrayNotEmpty(this.state.restaurants)
                        ? this.state.restaurants.map((restaurant, index) => {
                            return <tr key={index}>
                                <td>{restaurant.name}</td>
                                <td className='d-none d-xl-table-cell'>{restaurant.proximity ? restaurant.proximity.location : restaurant.locationInfo.location}</td>
                                <td className='d-none d-xl-table-cell'>{restaurant.breakfastAvailable ? FormConst.VALUE_YES : FormConst.VALUE_NO}</td>
                                <td className='d-none d-xl-table-cell'>{restaurant.lunchAvailable ? FormConst.VALUE_YES : FormConst.VALUE_NO}</td>
                                <td className='d-none d-xl-table-cell'>{restaurant.dinnerAvailable ? FormConst.VALUE_YES : FormConst.VALUE_NO}</td>
                                <td className='d-none d-lg-table-cell'>{restaurant.restaurantSpeciality?.description}</td>
                                <td><Button name={<FaEdit />} role='link' className={this.state.showNewRestaurantFields ? 'icon-link-disabled' : 'icon-link'} onClick={() => this.onEdit(index)} overridedisabledflag='true' /></td>
                                <td><Button name={<FaTrashAlt />} role='link' className={this.state.showNewRestaurantFields ? 'icon-link-disabled' : 'icon-link'} onClick={() => this.handleDelete(index)} /></td>
                            </tr>
                        })
                        : <tr>
                            <td colSpan={8}>There are no entries for restaurants</td>
                        </tr>
                }
            </tbody>
        </table>

        return (
            <Formik
                initialValues={this.state.initialValues}
                validationSchema={validationSchemaHotelDiningContent}
                enableReinitialize={true}
                onSubmit={(data, { setSubmitting, resetForm }) => {
                    if (!(data.isBreakfast || data.isLunch || data.isDinner) 
                        && (!this.state.canAccessHotelContentDining 
                            || (this.state.canAccessHotelContentDining && data.locationToHotel === 'Onsite' && !data.diningHoursVary)
                            || (this.state.canAccessHotelContentDining && data.locationToHotel !== 'Onsite'))) {
                        this.setState({
                            formError: 'At least one meal should be served'
                        })
                    } else {
                        setSubmitting(true)
                        this.handleSubmit(data)
                        setSubmitting(false)
                        resetForm()
                    }
                }}>
                {
                    ({ values, errors, touched, dirty, isSubmitting, isValid, resetForm, handleChange }) => (
                        <Form className='restaurants-form'>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                                    <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_DESTINATIONS_PAGE}>Destinations</NavLink></li>
                                    <li className="breadcrumb-item active" aria-current="page">Restaurants</li>
                                </ol>
                            </nav>
                            <p className='hotel-destinations-type'>Restaurants</p>
                            <p className='helper-text'>{FormConst.RESTAURANTS_HELPER_TEXT}</p>
                            <input name='canAccessHotelDining' id="canAccessHotelDining" type="hidden" value={this.state.canAccessHotelContentDining} />
                            {formTable}

                            {
                                this.state.restaurants.length < FormConst.DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_MAX_COUNT
                                && <div className='new-restaurants-fields-toggle'>
                                    <Button
                                        id='add-restaurant-button'
                                        name='Add Restaurant'
                                        disabled={this.state.showNewRestaurantFields}
                                        onClick={this.showNewRestaurantFields} />
                                </div>
                            }

                            {/* Show new restaurant fields only when add button is clicked */}
                            {
                                this.state.showNewRestaurantFields
                                && <div id='new-restaurant-collapse-fields'>
                                    <div className={this.state.canAccessHotelContentDining && values.locationToHotel === 'Onsite' ? 'new-restaurant-form-fields diningContentForm' : 'new-restaurant-form-fields'}>
                                        <TextInput name='restaurantName' type='text'
                                            label='Restaurant Name' isrequired='true' />
                                        <SelectInput name='locationToHotel' id="locationToHotel" type='text'
                                            label='Location' isrequired='true' options={FormConst.LOCATION_OPTIONS} />
                                            {
                                                this.state.canAccessHotelContentDining && values.locationToHotel === 'Onsite' &&
                                                <div>
                                                    <Row>
                                                        <Col xs={12} sm={12} xl={{ span: 20, offset: 0 }} className="shortDescriptionArea">
                                                            <p className='helper-text'>Short Description*</p>
                                                            <TextAreaInput
                                                                id='short-description-text-area'
                                                                name='shortDescription'
                                                                maxLength={FormConst.HOTEL_CONTENT_TYPE_MAX_CHARACTER_LIMIT.shortDescription}
                                                                rows={10}
                                                                isrequired='true'
                                                                title='Short Description' />
                                                            <p className='float-right'>Characters left: {FormConst.HOTEL_CONTENT_TYPE_MAX_CHARACTER_LIMIT.shortDescription - values.shortDescription.length}</p>
                                                        </Col>
                                                    </Row>
                                                    <p className='caption'>Timing Options</p>
                                                    <div className="timeToggle">
                                                        <ToggleSwitch
                                                            id='sameOperatingHours'
                                                            name='sameOperatingHours'
                                                            label='Do you use the same operating hours every day?'
                                                            checked={values.sameOperatingHours}
                                                            options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                            onChange={handleChange}
                                                            isrequired='false' />
                                                    </div>
                                                    <br/>
                                                    <div className={values.sameOperatingHours ? 'timeToggle hideField' : 'timeToggle'}>
                                                        <ToggleSwitch
                                                            id='diningHoursVary'
                                                            name='diningHoursVary'
                                                            label='Do your operating hours vary depending on the meal options you offer?'
                                                            checked={values.diningHoursVary}
                                                            options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                            onChange={handleChange}
                                                            isrequired='false' />
                                                            <br/>
                                                    </div>
                                                    {
                                                        !values.diningHoursVary &&
                                                        (
                                                            <div>
                                                                <ToggleSwitch
                                                                    id='is-breakfast'
                                                                    name='isBreakfast'
                                                                    checked={values.isBreakfast}
                                                                    label='Is Breakfast served?'
                                                                    options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                                    onChange={handleChange} />
                                                                <ToggleSwitch
                                                                    id='is-lunch'
                                                                    name='isLunch'
                                                                    checked={values.isLunch}
                                                                    label='Is Lunch served?'
                                                                    options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                                    onChange={handleChange} />
                                                                <ToggleSwitch
                                                                    id='is-dinner'
                                                                    name='isDinner'
                                                                    checked={values.isDinner}
                                                                    label='Is Dinner served?'
                                                                    options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                                    onChange={handleChange} />
                                                                <br />
                                                            </div>
                                                        )
                                                    }
                                                    {
                                                    values.sameOperatingHours &&
                                                    (
                                                        <Row className='leftAlignRow'>
                                                            <Col xs={12} sm={12} xl={{ span: 5, offset: 0 }}>
                                                                <TextInput id='detailedOperatingHours.dailyDoesntVary.hours.allDays.open' 
                                                                    name='detailedOperatingHours.dailyDoesntVary.hours.allDays.open' type='time' label='Opening Time' 
                                                                    isrequired='true' />
                                                            </Col>
                                                            <Col xs={12} sm={12} xl={{ span: 5, offset: 0 }}>
                                                                <TextInput id='detailedOperatingHours.dailyDoesntVary.hours.allDays.close' 
                                                                    name='detailedOperatingHours.dailyDoesntVary.hours.allDays.close' type='time' label='Closing Time' 
                                                                    isrequired='true'  />
                                                            </Col>
                                                        </Row>
                                                    )
                                                    }
                                                    {
                                                    !values.sameOperatingHours && !values.diningHoursVary &&
                                                    (
                                                        <div>
                                                            <p>Please enter your opening and closing times below.</p>
                                                            <div className='table-overflow'>
                                                                <OperatingHours
                                                                    name="detailsOperatingHours.DAILY"
                                                                    id='detailedOperatingHours.DAILY'
                                                                    day={values.detailedOperatingHours.DAILY}
                                                                    allValues={values.detailedOperatingHours}
                                                                />
                                                            </div>
                                                        </div>
                                                    )
                                                    }
                                                    {
                                                    !values.sameOperatingHours && values.diningHoursVary &&
                                                    (
                                                        <div className='timeTableSpacing'>
                                                            <p>Please enter your opening and closing times below.</p>
                                                            <input name="invisibleErrorField" type='hidden' />
                                                            <p className={"invalid " + (!values.breakfastCheckbox && !values.brunchCheckbox &&
                                                                !values.lunchCheckbox && !values.happyHourCheckbox && 
                                                                !values.dinnerCheckbox ? '': 'hideField')
                                                            }>Please select the meal options for your hotel; at least one must be selected.</p>
                                                            <div className='table-overflow'>
                                                            <OperatingHours
                                                                name="detailsOperatingHours.BREAKFAST"
                                                                id='detailedOperatingHours.BREAKFAST'
                                                                day={values.detailedOperatingHours.BREAKFAST}
                                                                allValues={values.detailedOperatingHours}
                                                                cellName='Breakfast'
                                                                tableDissabled={values.breakfastCheckbox}
                                                            />
                                                            </div>
                                                            <div className='table-overflow'>
                                                            <OperatingHours
                                                                name="detailsOperatingHours.BRUNCH"
                                                                id='detailedOperatingHours.BRUNCH'
                                                                day={values.detailedOperatingHours.BRUNCH}
                                                                allValues={values.detailedOperatingHours}
                                                                cellName='Brunch'
                                                                tableDissabled={values.brunchCheckbox}
                                                            />
                                                            </div>
                                                            <div className='table-overflow'>
                                                            <OperatingHours
                                                                name="detailsOperatingHours.LUNCH"
                                                                id='detailedOperatingHours.LUNCH'
                                                                day={values.detailedOperatingHours.LUNCH}
                                                                allValues={values.detailedOperatingHours}
                                                                cellName='Lunch'
                                                                tableDissabled={values.lunchCheckbox}
                                                            />
                                                            </div>
                                                            <div className='table-overflow'>
                                                            <OperatingHours
                                                                name="detailsOperatingHours.HAPPY_HOUR"
                                                                id='detailedOperatingHours.HAPPY_HOUR'
                                                                day={values.detailedOperatingHours.HAPPY_HOUR}
                                                                allValues={values.detailedOperatingHours}
                                                                cellName='Happy Hour'
                                                                tableDissabled={values.happyHourCheckbox}
                                                            />
                                                            </div>
                                                            <div className='table-overflow'>
                                                            <OperatingHours
                                                                name="detailsOperatingHours.DINNER"
                                                                id='detailedOperatingHours.DINNER'
                                                                day={values.detailedOperatingHours.DINNER}
                                                                allValues={values.detailedOperatingHours}
                                                                cellName='Dinner'
                                                                tableDissabled={values.dinnerCheckbox}
                                                            />
                                                            </div>
                                                        </div>
                                                    )
                                                    }
                                                    <br/>
                                                    <p className='caption'>Contact Details</p>
                                                    <Row>
                                                        <Col xs={12} sm={12} xl={{ span: 6, offset: 0 }}>
                                                            <TextInput
                                                                id='dining-phone-number'
                                                                name='phoneCountryCode'
                                                                type='tel'
                                                                label='Phone Number'
                                                                placeholder='CC'
                                                                title='Country Code'
                                                                suffix={
                                                                    <>
                                                                        <TextInput
                                                                            id='area-code'
                                                                            name='phoneAreaCode'
                                                                            type='num'
                                                                            label=' - '
                                                                            title='Area Code'
                                                                            placeholder='Area Code' />
                                                                        <TextInput
                                                                            id='phone-number'
                                                                            name='phoneNumber'
                                                                            type='tel'
                                                                            label=' - '
                                                                            title='Phone Number'
                                                                            placeholder='Number' />
                                                                    </>
                                                                }
                                                                 />
                                                            </Col>
                                                            <Col xs={12} sm={12} xl={{ span: 6, offset: 0 }}>
                                                                <TextInput id='email' name='email' type='text' label='Email' />
                                                            </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col xs={12} sm={12} xl={{ span: 6, offset: 0 }}>
                                                            <SelectInput id='typeOfCuisine' name='typeOfCuisine' type='tel' label='Type of Cuisine' options={this.state.restaurantSpecialtyOptions} isrequired='true' />
                                                        </Col>
                                                        <Col xs={12} sm={12} xl={{ span: 6, offset: 0 }}>
                                                            <SelectInput id='dressCode' name='dressCode' type='tel' label='Dress Code' options={this.state.dressCodeOptions} isrequired='false' />
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col xs={12} sm={12} xl={{ span: 6, offset: 0 }}>
                                                            <SelectInput id='detailedLocation' name='detailedLocation' type='tel' label='Detailed Location' options={this.state.locationOptions} />
                                                        </Col>
                                                        <Col xs={12} sm={12} xl={{ span: 6, offset: 0 }}>
                                                            <TextInput id='menuUrl' name='menuUrl' type='text' label='Menu URL' isrequired='false' />
                                                        </Col>
                                                    </Row>
                                                    
                                                    
                                                    <Row>
                                                        <Col xs={12} sm={12} xl={{ span: 6, offset: 0 }}>
                                                        {
                                                        (values.detailedLocation === 'Floor' || values.detailedLocation === 'Other') &&
                                                            <TextInput id='detailedLocationDescription' name='detailedLocationDescription' label={values.detailedLocation} type='text' isrequired='true' />
                                                        }
                                                        </Col>
                                                        <Col xs={12} sm={12} xl={{ span: 6, offset: 0 }}>
                                                            <TextInput id='websiteUrl' name='websiteUrl' type='text' label='Website URL' />
                                                        </Col>
                                                    </Row>
                                                </div> 
                                            }
                                            {
                                                (!this.state.canAccessHotelContentDining || values.locationToHotel !== 'Onsite') && 
                                                <div>
                                                    <ToggleSwitch
                                                        id='is-breakfast'
                                                        name='isBreakfast'
                                                        checked={values.isBreakfast}
                                                        label='Is Breakfast served?'
                                                        options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                        onChange={handleChange} />
                                                    <ToggleSwitch
                                                        id='is-lunch'
                                                        name='isLunch'
                                                        checked={values.isLunch}
                                                        label='Is Lunch served?'
                                                        options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                        onChange={handleChange} />
                                                    <ToggleSwitch
                                                        id='is-dinner'
                                                        name='isDinner'
                                                        checked={values.isDinner}
                                                        label='Is Dinner served?'
                                                        options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                        onChange={handleChange} />
                                                    <TextInput name='distance' type='number'
                                                        label='Distance' isdependent='true' suffix={this.state.distanceUnits}
                                                        disabled={values.locationToHotel === FormConst.VALUE_ONSITE || values.locationToHotel === FormConst.VALUE_ADJACENT}
                                                        min={0}
                                                        max={FormConst.MAX_DESTINATION_DISTANCE} step='0.5' />
                                                    <SelectInput name='direction' label='Direction'
                                                        isdependent='true' options={FormConst.DIRECTION_OPTIONS}
                                                        disabled={values.locationToHotel === FormConst.VALUE_ONSITE || values.locationToHotel === FormConst.VALUE_ADJACENT} />
                                                    <TextInput name='openingTime' type='time' label='Opening Time' isrequired='true' />
                                                    <TextInput name='closingTime' type='time' label='Closing Time' isrequired='true' />
                                                    <SelectInput name='speciality' type='text'
                                                        label='Specialty' isrequired='true' options={this.state.restaurantSpecialtyOptions} />
                                                </div>
                                            }
                                        {this.state.formError && <p className='error form-error'>{this.state.formError}</p>}
                                    </div>
                                    <Row>
                                        <Col xs={3} sm={2} lg={1}><Button role='link' type="submit" name={FormConst.SAVE_LINK_TEXT} className="new-restaurant-action-button" formNoValidate /></Col>
                                        <Col xs={4} sm={2} lg={1}><Button role='link' name={FormConst.DISCARD_LINK_TEXT} className="new-restaurant-action-button" onClick={() => {
                                            if (dirty) {
                                                this.handleClearForm()
                                            } else {
                                                this.discardNewFields(resetForm)
                                            }
                                        }
                                        }
                                            overridedisabledflag='true' /></Col>
                                    </Row>

                                </div>
                            }
                            {
                                this.state.showNewRestaurantFields
                                && <p className='error text-center'>Please save or discard your changes to proceed</p>
                            }

                            <FormFooter
                                form={{
                                    previous: { title: 'Destinations', route: RouteConst.ROUTE_DESTINATIONS_PAGE },
                                    next: { title: 'Lounges', route: RouteConst.ROUTE_LOUNGES_PAGE }
                                }}
                                submitName={this.state.continueFlow ? 'Proceed to Lounges' : 'Go back to Destinations'}
                                onSubmit={this.handleProceed}
                                submitDisabled={this.state.showNewRestaurantFields}
                                noReset />
                            <FormModal
                                id='restaurants-page-save-modal'
                                title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                hotelInfo={this.state.hotelInfo}
                                body={<h5>{this.state.loadingMessage}</h5>}
                                show={this.state.isLoading}
                                isLoadingIndicator />
                            <FormModal
                                id='restaurants-page-discard-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_DISCARD_ACTION_TITLE}
                                body={<h5>{FormConst.MODAL_DISCARD_ACTION_TEXT}</h5>}
                                proceed={() => {
                                    this.discardNewFields(resetForm)
                                }}
                                cancel={() => { this.setState({ showResetModal: false }) }}
                                show={this.state.showResetModal} />
                            <FormModal
                                id='restaurants-page-delete-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={'Delete Restaurant'}
                                body={<h5>{FormConst.MODAL_DELETE_ACTION_TEXT}</h5>}
                                proceed={this.onDelete}
                                cancel={() => { this.setState({ showDeleteModal: false }) }}
                                show={this.state.showDeleteModal} />
                            <FormModal
                                id='restaurants-page-error-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                body={<h5>{this.state.errorMessage}</h5>}
                                isError
                                cancel={() => { this.setState({ showErrorModal: false }) }}
                                show={this.state.showErrorModal} />
                        </Form>
                    )
                }
            </Formik>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        destinationsResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGet: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_HOTEL_DESTINATIONS_NAME, actionTypes.ASYNC_ACTIONS.GET, { hotelCode: hotelCode })),
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_HOTEL_DESTINATIONS_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(Restaurants, SideNavEntryMapping.HOTEL_DESTINATIONS))